import { useContext, useEffect } from 'react'

import { ComposerContext } from '../ComposerContext'
import { installFluxToProfileFieldsMirror } from './installFluxToProfileFieldsMirror'

/**
 * Mount the Flux→Zustand mutable-per-profile-fields mirror (INC-470
 * root-cause fix, CORE-7780) unconditionally — `channelSlice.profiles` has
 * no bridgeReady-style gate today (it's a synchronous one-time seed, see
 * `useSelectedProfiles.ts`), and matches every other forward mirror in this
 * migration ("mirrors mounted unconditionally", per
 * `.agents/rules/composer-state-bridge.md`).
 *
 * Must run inside `ComposerContext.Provider`.
 */
export function useChannelProfileFieldsMirror(): void {
  const store = useContext(ComposerContext)
  if (!store) {
    throw new Error(
      'useChannelProfileFieldsMirror must be used within ComposerProvider',
    )
  }

  useEffect(() => {
    const mirror = installFluxToProfileFieldsMirror(store)
    return mirror.unsubscribe
  }, [store])
}
